<template>
  <card-item
    card="item_order"
    :tabs="tabs"
    v-model="activeTab"
    :id="`${id}${$store.state.user.sections['orders'] ? '' : '000030003'}`"
  >
  </card-item>
</template>
<script>
export default {
  methods: {},
  props: ["id"],
  data() {
    return {
      tabs: [
        {
          title: "Информация",
          titleKey: "info",
          component: () => import("./Info"),
        },
        // {
        //   title: "Создать продажу",
        //   titleKey: "create_order",
        //   component: () => import("@/components/Partners"),
        // },
        // {
        //   title: "Сервисы",
        //   component: () => import("./Services"),
        // },
        {
          title: "Транзакции продаж",
          component: () => import("./Transactions"),
        },
      ],
      activeTab: 0,
    };
  },
};
</script>